import styled from "styled-components";
import COLORS from "@mlb/react-patterns/style/universal.color";
import { ButtonGroupWrapper } from "@mlb/react-patterns/components/ButtonGroup/buttonGroup.style";

const { mlbWhite } = COLORS;
const bgColor = "rgba(0, 0, 0, 0.8)";
const transparentBg = "rgba(0, 0, 0, 0.0)";
const brightBlue = "#4297FF";

export const PlaybackControlsWrapper = styled.div`
  pointer-events: all;
  position: absolute;
  bottom: 8px;
  box-sizing: border-box;
  display: flex;
  height: 31px;
  width: 98%;
  background-color: ${bgColor};
  margin: 0 1%;
  padding: 0 4px;
  border-radius: 10px;

  .button-wrapper {
    height: 100%;

    & > span {
      height: 100%;
    }
  }

  &.mobile {
    display: block;
    height: auto;
    width: 96%;
    margin: 0 2%;
    border-radius: 15px;

    .row {
      display: flex;
      justify-content: center;
      margin: 10px 0;

      &.top {
        height: 35px;
      }
    }

    .pair {
      display: flex;

      > * {
        margin: 0 8px;
      }

      .speed {
        font-size: large;
      }
    }

    svg {
      height: 100%;
      width: 24px;
    }

    .cam {
      svg {
        width: 34px;
      }
    }
  }
`;

export const PlaybackButton = styled.button`
  background: rgba(0, 0, 0, 0);
  border: 0;
  padding: 0 6px;
  height: 100%;

  > svg {
    stroke: #0000;
    vertical-align: middle;
  }
`;

export const SettingsButton = styled.button`
  background: rgba(0, 0, 0, 0);
  border: 0;
  padding: 0 6px;
  height: 100%;

  > svg {
    stroke: #0000;
    vertical-align: middle;
  }
`;

export const ExitFullscreenButton = styled.button`
  pointer-events: all;
  position: absolute;
  top: 16px;
  left: 16px;
  color: ${mlbWhite};
  height: 36px;
  width: 36px;
  background-color: ${bgColor};
  border: 0;
  border-radius: 10px;
  padding: 10px 8px;
`;

export const CameraOptionsPopoverWrapper = styled.div`
  [data-popper-placement] {
    background-color: ${bgColor};
    border: 0;

    > :before {
      border-top: 1em solid rgba(0, 0, 0, 0);
    }
    > :after {
      border-top: 1em solid rgba(0, 0, 0, 0);
    }
  }
`;

export const SettingsMenuPopoverWrapper = styled.div`
  [data-popper-placement] {
    background-color: ${bgColor};
    border: 0;

    > :before {
      border-top: 1em solid rgba(0, 0, 0, 0);
    }
    > :after {
      border-top: 1em solid rgba(0, 0, 0, 0);
    }
  }
`;

export const CameraOptionsWrapper = styled.div`
  font-family: var(--gameday-primary-font);
  width: 250px;
  margin: 24px 0;

  > div {
    margin-left: 16px;
    color: ${mlbWhite};
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    text-transform: uppercase;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  ${ButtonGroupWrapper} {
    width: 225px;
    display: block;
    margin: auto;

    button {
      border-radius: 28px;
      width: 100%;
      height: 48px;
      display: block;
      font-style: normal;
      margin-bottom: 16px;
      color: ${mlbWhite};
      border: 1px solid ${brightBlue};

      &[data-selected="true"],
      &:hover {
        background-color: ${brightBlue};
        color: ${mlbWhite};
      }
    }
  }
`;

export const CloseSettingsButton = styled.button`
  position: absolute;
  background-color: ${transparentBg};
  border: 0;
  top: 12px;
  right: 12px;
`;

export const SettingsMenuWrapper = styled.div`
  font-family: var(--gameday-primary-font);
  width: 343px;
  margin: 16px;

  .mobile & {
    width: auto;
  }

  > div {
    color: ${mlbWhite};
    font-weight: 700;
    font-size: 14px;
    line-height: 14px;
    text-transform: uppercase;
    margin-bottom: 16px;
  }

  ${ButtonGroupWrapper} {
    display: flex;

    button {
      border-radius: 28px;
      width: 50%;
      height: 40px;
      font-style: normal;
      margin: 0 4px 0 4px;
      color: ${mlbWhite};
      background-color: #555;

      &[data-selected="true"],
      &:hover {
        background-color: ${brightBlue};
        color: ${mlbWhite};
      }
    }
  }
`;

export const TimelineWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  padding: 8px;
  input[type="range"] {
    position: relative;
    align-items: center;
    margin: auto;
    justify-self: center;
    width: 100%;
    height: 6px;
    -webkit-appearance: none;
    background: #b8bab1;
    border-radius: 4px;
    background-image: linear-gradient(#fff, #fff);
    background-size: 0%;
    background-repeat: no-repeat;
    ::-webkit-slider-thumb {
      -webkit-appearance: none;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #fff;
    }
    ::-moz-range-thumb {
      -webkit-appearance: none;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #fff;
    }
    ::-ms-thumb {
      -webkit-appearance: none;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #fff;
    }
    ::-webkit-slider-runnable-track {
      -webkit-appearance: none;
      box-shadow: none;
      border: none;
      background: transparent;
    }
    ::-moz-range-track {
      -webkit-appearance: none;
      box-shadow: none;
      border: none;
      background: transparent;
    }
    ::-ms-track {
      -webkit-appearance: none;
      box-shadow: none;
      border: none;
      background: transparent;
    }
  }
`;

export const TimeDisplay = styled.div`
  color: #fff;
  font-size: 0.8em;
  text-align: center;
  white-space: nowrap;
  cursor: default;
  margin: auto;
  display: flex;

  > div {
    width: 46px;
    padding-right: 4px;
  }

  .mobile & {
    font-size: 1em;
  }
`;

export const LoopButtonWrapper = styled.div`
  position: absolute;
  left: 16px;
  bottom: 75px;
`;
